import { useTranslation } from 'react-i18next';

import { useAppDispatch, useAppSelector } from 'hooks';
import { Permissions } from 'entities/dashboard';
import Modal from 'components/Modal';

import { closeSignatoryPopup } from '../../submitDashboardSlice';
import { getIsSignatoryPopupOpen } from '../../selectors';
import SignatoryDetailsForm from './SignatoryDetailsForm';

type SignatoryDetailsModalProps = {
  permission?: Permissions;
};

const SignatoryDetailsModal: React.FC<SignatoryDetailsModalProps> = ({
  permission,
}) => {
  const { t } = useTranslation('dashboard');
  const dispatch = useAppDispatch();

  const isOpen = useAppSelector(getIsSignatoryPopupOpen);

  const handleCancel = () => {
    dispatch(closeSignatoryPopup());
  };

  return (
    <Modal
      isOpen={isOpen}
      closeModal={handleCancel}
      isOverlayDisabled
      title={t('dashboard:signatory.details.title')}
      maxWidth="512px"
      zIndex={40}
      closeTimeoutMS={0}
    >
      {isOpen && (
        <SignatoryDetailsForm onCancel={handleCancel} permission={permission} />
      )}
    </Modal>
  );
};

export default SignatoryDetailsModal;
